'use client';

import React from 'react';
import { createRoot } from 'react-dom/client';

interface ThisSiteComponentProps {
  componentId: string;
  onUpdate: (componentId: string, data: any) => void;
  onRemove: (componentId: string) => void;
}

const ThisSiteComponent: React.FC<ThisSiteComponentProps> = ({
  componentId,
  onUpdate,
  onRemove,
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  // Keep this as a safety backup - component data is now registered synchronously in renderComponentByType
  // but this ensures data is available even if component is re-rendered or remounted
  React.useLayoutEffect(() => {
    onUpdate(componentId, {
      type: 'this_site',
      connector: 'ANY',
    });
  }, [componentId, onUpdate]);

  return (
    <span
      className="inline-flex items-center gap-1 text-teal-600 text-sm font-semibold group"
      data-testid="this-site-component"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span data-testid="this-site-label">this site</span>
      <button
        className={`text-xs transition-all ${
          isHovered
            ? 'text-red-500 hover:text-red-700 opacity-100'
            : 'text-gray-400 opacity-0 w-0 group-hover:opacity-100 group-hover:w-auto'
        }`}
        onClick={(e) => {
          e.stopPropagation();
          onRemove(componentId);
        }}
        aria-label="Remove this site"
        data-testid="this-site-remove-button"
      >
        ×
      </button>
    </span>
  );
};

export default ThisSiteComponent;

// Static method to render into a DOM element (for contentEditable integration)
export const renderThisSiteComponent = (
  container: HTMLElement,
  props: ThisSiteComponentProps
) => {
  const root = createRoot(container);
  root.render(<ThisSiteComponent {...props} />);
  return root;
};
